module.exports = __webpack_public_path__ + "static/media/编组 45@2x.2f94a0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/编组 45@2x.png
// module id = 1548
// module chunks = 0